import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { adminApi, getApiErrorMessage } from '../services/adminApi'
import { Alert, FormActions, FormSection, Input, PageHeader, Select } from '../components/ui'

export default function AdminForm() {
  const navigate = useNavigate()
  const [form, setForm] = useState({ email: '', password: '', role: 'support' })
  const [saving, setSaving] = useState(false)
  const [error, setError] = useState('')

  async function submit(event) {
    event.preventDefault()
    if (saving) return
    setSaving(true)
    setError('')
    try {
      await adminApi.registerAdmin(form)
      navigate('/admins', { replace: true, state: { message: 'Administrador criado com sucesso.' } })
    } catch (err) {
      setError(getApiErrorMessage(err))
    } finally {
      setSaving(false)
    }
  }

  return (
    <form onSubmit={submit} className="space-y-6">
      <PageHeader eyebrow="Segurança" title="Novo administrador" description="Crie um acesso global e defina o nível de permissão inicial." icon="fa-user-shield" />
      {error && <Alert type="error">{error}</Alert>}
      <FormSection title="Credenciais e perfil" description="O acesso será válido para a área administrativa global." icon="fa-key">
        <div className="grid gap-4 md:grid-cols-2">
          <Input label="E-mail *" type="email" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} required autoFocus autoComplete="username" />
          <Input label="Senha inicial *" type="password" value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} required autoComplete="new-password" />
          <Select label="Perfil *" value={form.role} onChange={(e) => setForm({ ...form, role: e.target.value })} hint="Super Admin possui acesso às operações mais sensíveis.">
            <option value="support">Suporte</option>
            <option value="super_admin">Super Admin</option>
          </Select>
        </div>
      </FormSection>
      <FormActions onCancel={() => navigate('/admins')} saving={saving} submitLabel="Criar administrador" />
    </form>
  )
}
